/**
 * wanteeed — coupons / cashback shopping assistant
 *
 * A single WAR entry exposes `*` — every bundled file — to every origin with no
 * use_dynamic_url, so the whole package is fetchable from any page at a fixed URL. The
 * vendor-named `icons/app-128.png` is an image, so it loads through probeImage with no
 * CORS grant and survives a strict page CSP.
 *
 * Manifest verified against version 2.638.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'emnoomldgleagdjapdeckpmebokijail';

export const wanteeed: ExtensionDefinition = {
  id: ID,
  name: 'wanteeed',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  notes:
    'Exposes every bundled file ("*") to every origin with no dynamic URL. The app-128 ' +
    'icon is conclusive and loads without a CORS grant.',
  signals: [
    {
      id: 'war-app-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icons/app-128.png via <img> — the app icon exposed to every origin; needs no ' +
        'CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icons/app-128.png'),
    },
    {
      id: 'war-panel-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/panel.css — the injected panel stylesheet, a second path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/panel.css'),
    },
    {
      id: 'war-ds-fonts-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch ds-fonts.css — the design-system font stylesheet, independent of the icon ' +
        'and panel paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'ds-fonts.css'),
    },
  ],
};
